export enum AuthenticationActions {
  CARREGAR_USER_INFO = 'AUTHENTICATION_CARREGAR_USER_INFO',
  LOADING_USER_INFO = 'AUTHENTICATION_LOADING_USER_INFO',
  DEFINIR_TENANT = 'DEFINIR_TENANT',
  DEFINIR_TOKEN = 'DEFINIR_TOKEN'
}
